import script from "./manualPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./manualPayments.vue?vue&type=script&setup=true&lang=js"

import "./manualPayments.vue?vue&type=style&index=0&id=a0593938&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0593938"]])

export default __exports__